import React, { useCallback } from 'react';
import classNames from 'classnames';
import { MenuList as MuiMenuList } from '@material-ui/core';
import { makeStyles } from "../../styles/index";
var useStyles = makeStyles(function () { return ({
    root: {
        padding: 0,
        outline: 'none',
    },
}); }, { name: 'SnMenuList' });
/**
 * メニューリストコンポーネント。
 */
export var MenuList = function (props) {
    var children = props.children, className = props.className, autoFocusItem = props.autoFocusItem, onCancel = props.onCancel, onNext = props.onNext, onPrev = props.onPrev;
    var classes = useStyles(props);
    var handleListKeyDown = useCallback(function (event) {
        if (event.key === 'Escape' && onCancel != null) {
            event.preventDefault(); // onCancelが指定されていない場合はデフォルトの挙動を残す
            onCancel();
        }
        if (event.key === 'Tab' && !event.shiftKey && onNext != null) {
            event.preventDefault(); // onNextが指定されていない場合はデフォルトの挙動を残す
            onNext();
        }
        if (event.key === 'Tab' && event.shiftKey && onPrev != null) {
            event.preventDefault(); // onPrevが指定されていない場合はデフォルトの挙動を残す
            onPrev();
        }
    }, [onCancel, onNext, onPrev]);
    return (React.createElement(MuiMenuList, { className: classNames(classes.root, className), autoFocusItem: autoFocusItem, onKeyDown: handleListKeyDown }, children));
};
